// ANCHOR React
import { FormEvent } from 'react';

// ANCHOR Base
import { LABEL_PLACEMENT, Checkbox } from 'baseui/checkbox';
import { Block } from 'baseui/block';
import { LabelMedium } from 'baseui/typography';

// ANCHOR Models
import { useUpdateFormFormShowScore } from '@lyon/scoped-models/form/update/UpdateFormForm';

// ANCHOR Hooks
import { useConstantCallback } from '@lyonph/react-hooks';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { HelpTooltip } from '@lyon/components/utils/HelpTooltip';

// ANCHOR Contants
import { LABEL, MESSAGE } from './constants';

export const LyonUpdateFormShowScore = constant(() => {
  const [showScore, setShowScore] = useUpdateFormFormShowScore();

  const onChange = useConstantCallback(
    (event: FormEvent<HTMLInputElement>) => {
      event.preventDefault();

      setShowScore((currentValue) => !currentValue);
    },
  );

  return (
    <Block
      display="grid"
      gridTemplateColumns="auto 1fr"
      gridColumnGap="16px"
      alignItems="center"
      marginTop="32px"
    >
      <Checkbox
        name={LABEL}
        title={LABEL}
        ariaLabel={LABEL}
        checked={showScore}
        onChange={onChange}
        labelPlacement={LABEL_PLACEMENT.right}
      >

        <LabelMedium>
          {LABEL}
        </LabelMedium>
      </Checkbox>
      <HelpTooltip message={MESSAGE} placement="top" />
    </Block>
  );
});
